import Risk from 'components/risk';

const RiskPage = () => {
  return <Risk />;
};

export default RiskPage;
